import { Button } from 'react-bootstrap';
import { errorToast } from '../helpers/toasts/ToastUtils';

const SiteButton = ({
  site,
  summary,
  selectedSite,
  selectSite,
  soilMoisture,
  isBlueAlert
}) => {
  // Terraprobe site button.
  if (site.type === 'terraprobe') {
    const siteName = `${site.name ?? '-'} `;
    return (
      <Button
        key={site.id}
        className='mx-2 my-2'
        variant={`${
          selectedSite && site.id === selectedSite.id ? '' : 'outline-'
        }${
          summary
            ? summary.alert_level === 3
              ? isBlueAlert
                ? 'primary'
                : 'danger'
              : summary.alert_level === 2
              ? 'warning'
              : summary.alert_level === 1
              ? 'success'
              : 'secondary'
            : 'secondary'
        }`}
        onClick={() => {
          if (site.application_rate == null) {
            errorToast(
              'Missing critical site information. Please contact support.'
            );
          }
          selectSite(site);
        }}
      >
        {`${siteName}${
          soilMoisture !== null ? ` ${Math.round(soilMoisture * 100)}%` : ''
        }`}
      </Button>
    );
  }
  // Irrimax site button.
  if (site.type === 'irrimax') {
    const siteName = site.irrimax_sites?.[0]?.custom_site_name || site.name;
    return (
      <div>
        <Button
          key={site.id}
          className='mx-2 my-2'
          variant={
            selectedSite && site.id === selectedSite.id
              ? 'dark'
              : 'outline-dark'
          }
          onClick={() => {
            selectSite(site);
          }}
        >
          <img
            src='https://fruition-metwatch-assets.s3-ap-southeast-2.amazonaws.com/sentek-logo-16.png'
            alt='sentek-logo'
            style={{ paddingBottom: '2px', marginRight: '2px' }}
          />{' '}
          {siteName}
        </Button>
      </div>
    );
  }
  // Invalid site type.
  return null;
};

export default SiteButton;

